/**
 * OpentokRecording AudioTrack implementation.
 *
 * @copyright Realeyes OU. All rights reserved.
 */

import audioActivity from 'audio-activity';
import MediaTrackType from '../recording/MediaTrackType';


/**
 * @implements {IAudioTrack}
 */
export default class AudioTrack {
    /**
     * @param {MediaStream} gumStream GUM stream
     * @param {IDevice} device Audio Device
     */
    constructor(gumStream, device) {
        this.gumStream = gumStream;
        this.device = device;
        this.audio = audioActivity(this.gumStream);
    }

    /**
     * Returns audio activity level
     * @return {Promise.<{ activityLevel: number, data: Array }>}
     */
    getActivity() {
        return new Promise(
            (resolve, reject) => {
                try {
                    const activityLevel = Math.round(this.audio.get() * 100);
                    resolve({ activityLevel }); // scale to 0-100
                } catch (err) {
                    reject(`Something went wrong at getActivity method err: ${err}`);
                }
            },
        );
    }

    /**
     * @return {IDevice}
     */
    getDevice() {
        return this.device;
    }

    /**
     * @return {string}
     */
    getType() {
        return MediaTrackType.AUDIO;
    }

    /**
     * releases resources
     * @return {Promise}
     */
    dispose() {
        if (this.audio !== null) {
            this.audio.destroy();
            this.audio = null;
        }

        return Promise.resolve();
    }
}
